import "./voucherdialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { finishSale, type SaleFinishOptions } from "../../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../../Common/Buttons/Button";

const connector = connect();

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    options: SaleFinishOptions;
}

class VoucherRetryDialog extends React.Component<Props> {
    protected handleRetryPress = (): void => {
        this.props.dispatch(finishSale("COMPLETED", {
            ...this.props.options,
            voucherFailed: false,
        }));
    };

    protected handleCancelPress = (): void => {
        this.props.dispatch(finishSale("COMPLETED", {
            ...this.props.options,
            voucherCancel: true,
        }));
    };

    public render(): React.ReactNode {
        return (
            <div className="voucher-activate-method">
                <div className="voucher-activate-heading">
                    Retry Voucher
                </div>
                <div className="voucher-description">
                    Voucher Activation failed, retry?
                </div>
                <div className="voucher-methods">
                    <Button onClick={this.handleRetryPress}>Retry</Button>
                    <Button onClick={this.handleCancelPress}>Cancel</Button>
                </div>
            </div>
        );
    }
}

export default connector(VoucherRetryDialog);
